export const howItWorks = {
  hero: {
    badge: "Guia completo",
    title: "Como funciona a DONKEY TRAVEL?",
    subtitle:
      "Descubra passo a passo como trocar sua casa Airbnb com outros proprietários e viajar gratuitamente por toda a Europa.",
    cta: "Começar agora",
    learnMore: "Ver as etapas",
  },
  stats: {
    properties: "Alojamentos disponíveis",
    exchanges: "Trocas realizadas",
    countries: "Países cobertos",
    satisfaction: "Satisfação",
  },
  steps: {
    badge: "O processo",
    title: "Sua troca em 7 etapas",
    subtitle:
      "Um percurso simples e seguro, da inscrição à sua primeira viagem gratuita",
    step1: {
      title: "Crie seu perfil (15 min)",
      description:
        'É a etapa mais "longa": 15 minutos para criar seu perfil. Um pequeno esforço para anos de férias gratuitas e felicidade!',
      highlight1: "Assinatura necessária",
      highlight2: "Anúncio completo com fotos",
      highlight3: "Verificação de identidade",
      badge: "Inscrição rápida",
    },
    step2: {
      title: "Explore e encontre seu destino ideal",
      description:
        "Navegue pelo nosso mapa interativo da Europa e encontre anfitriões verificados do clube. Filtre por destino, datas, tipo de alojamento e equipamentos para organizar sua troca.",
      highlight1: "Mapa interativo Europa com filtros avançados",
      highlight2: "Pesquisa por destino, datas e equipamentos",
      highlight3:
        "Membros anfitriões verificados nos países europeus disponíveis",
      badge: "Pesquisa inteligente",
    },
    step3: {
      title: "Proponha uma troca e negocie",
      description:
        "Contacte o proprietário que lhe interessa e proponha uma troca. Negocie as datas e a duração em um espírito amigável. 10 noites contra 5? Tudo é possível!",
      highlight1: "Mensagens integradas e seguras",
      highlight2: "Negociação flexível das durações",
      highlight3: "Perfis verificados e avaliações consultáveis",
      badge: "Negociação fácil",
    },
    step4: {
      title: "Confirme as datas e sincronize seus calendários",
      description:
        "Uma vez encontrado o acordo, confirme as datas de troca. Seus calendários Airbnb e DONKEY TRAVEL sincronizam-se automaticamente para evitar qualquer conflito de reserva.",
      highlight1: "Sincronização automática com Airbnb",
      highlight2: "Lembretes e notificações antes da estadia",
      highlight3: "Modificação flexível até 48h antes",
      badge: "Calendário sincronizado",
    },
    step5: {
      title: "Contrato amigável PDF enviado aos dois anfitriões",
      description:
        "A DONKEY TRAVEL edita um contrato amigável em PDF e envia aos dois anfitriões. Uma vez terminada a primeira troca, você tem 24 meses para efetuar a troca de retorno.",
      highlight1:
        "Contrato amigável PDF enviado automaticamente aos 2 anfitriões",
      highlight2: "Documento recapitulativo das datas e condições validadas",
      highlight3:
        "24 meses para realizar a troca de retorno após a primeira estadia",
      badge: "Contrato PDF",
    },
    step6: {
      title: "Viaje e aproveite sua estadia gratuita!",
      description:
        "É o grande dia! Installe-se no seu alojamento de troca e desfrute de férias autênticas. Após sua estadia, deixe uma avaliação para ajudar a comunidade.",
      highlight1: "Acolhimento personalizado pelo proprietário",
      highlight2: "Guia local com recomendações",
      highlight3: "Sistema de avaliações após cada troca",
      badge: "Boa viagem!",
    },
  },
  advantages: {
    badge: "Nossas vantagens",
    title: "Por que escolher a DONKEY TRAVEL?",
    subtitle:
      "Uma plataforma pensada para os proprietários Airbnb que querem viajar de outra forma",
    items: {
      security: {
        title: "Segurança máxima",
        description:
          "Todos os membros são proprietários Airbnb verificados. Identidade controlada, avaliações consultáveis e seguro incluído para cada troca.",
      },
      savings: {
        title: "Economias consideráveis",
        description:
          "Viaje gratuitamente trocando suas noites. Economize em média 2 500€ por ano em custos de alojamento.",
      },
      community: {
        title: "Comunidade de confiança",
        description:
          "Junte-se à nossa comunidade de viajantes. Partilhe suas experiências, troque conselhos e crie laços duradouros.",
      },
      support: {
        title: "Suporte 7/7",
        description:
          "Nossa equipe está disponível a qualquer momento para acompanhá-lo. Chat ao vivo, email e telefone para uma assistência completa.",
      },
      quality: {
        title: "Alojamentos de qualidade",
        description:
          "Cada alojamento é verificado e avaliado pela comunidade. Padrões elevados para garantir estadias excepcionais.",
      },
      global: {
        title: "Rede europeia",
        description:
          "Aceda a anfitriões verificados nos países europeus disponíveis do clube e organize suas trocas com confiança.",
      },
    },
  },
  testimonials: {
    badge: "Testemunhos",
    title: "Eles testaram e aprovaram",
    subtitle: "Descubra as experiências de nossos membros pelo mundo",
    banner: {
      title: "Você também pode viajar com mais frequência!",
      subtitle:
        "Junte-se à comunidade de anfitriões que viajam de forma diferente.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Paris, França",
        badge: "2 trocas",
        text: "Graças ao DONKEY TRAVEL, visitei Barcelona, Roma e Amsterdã sem pagar alojamento. A comunidade é reativa e as conversas de troca são fáceis.",
      },
      marc: {
        name: "Marc",
        location: "Marselha, França",
        badge: "1 troca",
        text: "O processo é incrivelmente simples. Em 3 dias, encontrei a troca perfeita para as minhas férias de verão. A sincronização com o Airbnb é uma grande vantagem.",
      },
      leaTom: {
        name: "Léa e Tom",
        location: "Lyon, França",
        badge: "Novos membros",
        text: "O que mais nos impressionou foi a comunidade. Os proprietários são atenciosos e as trocas decorrem num ambiente de total confiança.",
      },
      dupont: {
        name: "Família Dupont",
        location: "Bordéus, França",
        badge: "3 trocas",
        text: "Ideal para viagens em família durante as férias escolares!",
      },
      alex: {
        name: "Alex",
        location: "Berlim, Alemanha",
        badge: "5 trocas",
        text: "Uma rede incrível para o teletrabalho. Troco o meu loft em Berlim por apartamentos ao sol.",
      },
      marie: {
        name: "Marie",
        location: "Toulouse, França",
        badge: "4 trocas",
        text: "Acabaram-se as restrições financeiras! Faço uma escapadela de fim de semana todos os meses.",
      },
      testimonial2: {
        text: "O processo é tão simples. Em 3 dias, encontrei uma troca perfeita para minhas férias de verão. A sincronização com Airbnb é uma vantagem real.",
      },
      testimonial3: {
        text: "O que mais me seduziu foi a comunidade. Os proprietários são atenciosos e as trocas são feitas num ambiente de total confiança.",
      },
    },
  },
  faq: {
    title: "Perguntas frequentes",
    subtitle: "Tudo o que você precisa saber antes de começar",
    items: {
      q1: {
        question: "A inscrição é paga?",
        answer:
          "Sim. O acesso à DONKEY TRAVEL é feito através de uma assinatura anual. Oferta de lançamento 2026: 25EUR/ano em vez de 50EUR/ano.",
      },
      q2: {
        question: "Devo ser proprietário Airbnb para me inscrever?",
        answer:
          "Sim, a DONKEY TRAVEL é reservada a proprietários com um imóvel listado no Airbnb. Isso garante a qualidade e a confiabilidade de cada membro da comunidade.",
      },
      q3: {
        question: "Como as trocas são protegidas?",
        answer:
          "Cada troca é coberta pelo nosso seguro parceiro. Além disso, todos os membros são verificados (identidade, alojamento, avaliações Airbnb) e nossa equipe de suporte está disponível 7/7.",
      },
      q4: {
        question: "Posso trocar com alguém em outro país?",
        answer:
          "Sim. Você pode trocar com outros anfitriões verificados nos países europeus disponíveis de acordo com sua assinatura.",
      },
      q5: {
        question: "O que acontece se a troca for cancelada?",
        answer:
          "Nossa política de cancelamento protege ambas as partes. Em caso de cancelamento, ajudamos você a encontrar uma alternativa.",
      },
      q6: {
        question: "Quanto tempo dura uma troca em média?",
        answer:
          "A duração é totalmente flexível e é negociada entre os dois proprietários. Em média, as trocas duram entre 5 e 14 noites, mas alguns fazem trocas de um fim de semana ou de um mês inteiro.",
      },
    },
  },
  cta: {
    title: "Pronto para viajar gratuitamente?",
    subtitle: "Junte-se à nossa comunidade de viajantes.",
    explore: "Explorar os destinos",
    members: "Membros ativos",
    countries: "Países disponíveis",
    satisfaction: "De satisfação",
  },
};
